import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/Question/finish.gif'


const _withScopeId = n => (_pushScopeId("data-v-0103867e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"background-color":"#fafafa"}
}
const _hoisted_2 = {
  id: "payment",
  class: "body-max-width"
}
const _hoisted_3 = { class: "center" }
const _hoisted_4 = { class: "card-container fs-16 fw-500" }
const _hoisted_5 = { class: "total flex-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fc-2B2A2A" }, "Total", -1))
const _hoisted_7 = { class: "fc-4AA19B ml-auto" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_9 = { class: "payment flex-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fc-2B2A2A" }, "Payment method", -1))
const _hoisted_11 = { class: "fc-4AA19B ml-auto" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  id: "payment",
  class: "body-max-width"
}
const _hoisted_14 = { class: "center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pt-40 pb-40" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "mx-auto",
    style: {"width":"100%","max-width":"19rem","height":"100%","object-fit":"scale-down"}
  })
], -1))
const _hoisted_16 = { class: "fs-20 fw-500" }
const _hoisted_17 = {
  class: "flex-center mx-auto",
  style: {"max-width":"36rem"}
}
const _hoisted_18 = { class: "remove-padding-dialog" }
const _hoisted_19 = { class: "center p-28" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs-20 fw-500" }, "ใส่รหัสเพื่อดำเนินการธุรกรรม", -1))
const _hoisted_21 = { class: "flex-center mt-18" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "fs-12 mt-12 underline right",
  style: {"color":"#206b5e"}
}, [
  /*#__PURE__*/_createElementVNode("span", null, " forgot password?")
], -1))
const _hoisted_23 = { class: "flex-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.paymentFillPassword)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Header, {
              back: "/package-for-you",
              title: "Payment"
            }),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.numberWithCommas(_ctx.paymentData.value)) + " Baht ", 1)
                ]),
                _hoisted_8,
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, " Credit(*" + _toDisplayString(_ctx.paymentData.creditCardForShowing) + ") ", 1)
                ])
              ]),
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.passwordDialog = true)),
                class: "btn btn-48 btn-primary m-auto",
                style: {"width":"17.5rem","margin-top":"6rem"}
              }, " Confirm ")
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_Header, {
              back: "disable",
              title: "Payment"
            }),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, " คุณได้ชำระเงินจำนวน " + _toDisplayString(_ctx.numberWithCommas(29000)) + " บาท ", 1),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/home'))),
                  class: "btn btn-48 btn-C4C4C4 mr-auto mt-24",
                  style: {"width":"17rem"}
                }, " กลับหน้าแรก "),
                _createElementVNode("div", {
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/qr-code'))),
                  class: "btn btn-48 btn-primary ml-auto mt-24",
                  style: {"width":"17rem"}
                }, " ไปหน้าการสั่งซื้อ ")
              ])
            ])
          ])
        ])),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.passwordDialog,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.passwordDialog) = $event)),
        onClosed: _ctx.closeModalConfirm,
        width: "35.5rem"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _withDirectives(_createElementVNode("input", {
                ref: "pincode_1",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pincode.pincode1) = $event)),
                onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.checkedOTPOne && _ctx.checkedOTPOne(...args))),
                onChange: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.triggerPasteOTP && _ctx.triggerPasteOTP(...args)), ["prevent"])),
                class: _normalizeClass([{ validate: _ctx.pincodeValidate }, "pincode-input"]),
                type: "number",
                pattern: "[0-9]*",
                inputmode: "decimal"
              }, null, 34), [
                [_vModelText, _ctx.pincode.pincode1]
              ]),
              _withDirectives(_createElementVNode("input", {
                ref: "pincode_2",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.pincode.pincode2) = $event)),
                onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.checkedOTPTwo && _ctx.checkedOTPTwo(...args))),
                class: _normalizeClass([{ validate: _ctx.pincodeValidate }, "pincode-input"]),
                type: "number",
                inputmode: "decimal",
                pattern: "[0-9]*"
              }, null, 34), [
                [_vModelText, _ctx.pincode.pincode2]
              ]),
              _withDirectives(_createElementVNode("input", {
                ref: "pincode_3",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pincode.pincode3) = $event)),
                onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.checkedOTPThree && _ctx.checkedOTPThree(...args))),
                class: _normalizeClass([{ validate: _ctx.pincodeValidate }, "pincode-input"]),
                type: "number",
                inputmode: "decimal",
                pattern: "[0-9]*"
              }, null, 34), [
                [_vModelText, _ctx.pincode.pincode3]
              ]),
              _withDirectives(_createElementVNode("input", {
                ref: "pincode_4",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.pincode.pincode4) = $event)),
                onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.checkedOTPFour && _ctx.checkedOTPFour(...args))),
                class: _normalizeClass([{ validate: _ctx.pincodeValidate }, "pincode-input"]),
                type: "number",
                inputmode: "decimal",
                pattern: "[0-9]*"
              }, null, 34), [
                [_vModelText, _ctx.pincode.pincode4]
              ]),
              _withDirectives(_createElementVNode("input", {
                ref: "pincode_5",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.pincode.pincode5) = $event)),
                onInput: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.checkedOTPFive && _ctx.checkedOTPFive(...args))),
                class: _normalizeClass([{ validate: _ctx.pincodeValidate }, "pincode-input"]),
                type: "number",
                inputmode: "decimal",
                pattern: "[0-9]*"
              }, null, 34), [
                [_vModelText, _ctx.pincode.pincode5]
              ]),
              _withDirectives(_createElementVNode("input", {
                ref: "pincode_6",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.pincode.pincode6) = $event)),
                onInput: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.checkedOTPSix && _ctx.checkedOTPSix(...args))),
                class: _normalizeClass([{ validate: _ctx.pincodeValidate }, "pincode-input"]),
                type: "number",
                inputmode: "decimal",
                pattern: "[0-9]*"
              }, null, 34), [
                [_vModelText, _ctx.pincode.pincode6]
              ])
            ]),
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", {
                onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.closeModalConfirm && _ctx.closeModalConfirm(...args))),
                class: "btn btn-48 btn-C4C4C4 mr-auto mt-24",
                style: {"width":"14rem"}
              }, " Cancle "),
              _createElementVNode("div", {
                onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.confirmPassword && _ctx.confirmPassword(...args))),
                class: "btn btn-48 btn-primary ml-auto mt-24",
                style: {"width":"14rem"}
              }, " Confirm ")
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "onClosed"])
    ])
  ], 64))
}